import { API, Amplify } from 'aws-amplify'

// for account spoof start
import { store } from '../../../wrap-with-provider'
import awsconfig from '../../aws-exports'

store.subscribe(listener)

export let spoofMode: boolean = false
export let spoofedUserId = ''

function selectSpoofMode(state) {
  return state.ui.spoofMode
}

function selectSpoofedUserId(state) {
  return state.ui.spoofedUserId
}

function listener() {
  spoofMode = selectSpoofMode(store.getState())
  spoofedUserId = selectSpoofedUserId(store.getState())
}

// account spoof end

if (process.env.NODE_ENV === 'development') {
  awsconfig.aws_cloud_logic_custom = awsconfig.aws_cloud_logic_custom.map(config => {
    if (config.name === 'wwwREST' && process.env.GATSBY_IS_DOCKER) {
      config.endpoint = 'http://host.docker.internal:3000'
    } else if (config.name === 'wwwREST') {
      config.endpoint = 'http://localhost:3000'
    }
    return config
  })
}

Amplify.configure(awsconfig)

export default API
